module.exports = __webpack_public_path__ + "img/share_error_2.2f6859f0.svg";